import { PortalBlock, PortalBlockType, ScreenItem, ScreenType } from '@nx-frontend/shared/types';

export const controlbarBlockEditRouter = (initialBlock: PortalBlock): ScreenItem => {
  const block = initialBlock.projection ?? initialBlock;

  if (block.type === PortalBlockType.EMBED) {
    return {
      type: ScreenType.BLOCK_EMBED,
      payload: { editItemId: block.id, embedType: block.embedType, place: block.place },
    };
  }
  if (block.type === PortalBlockType.INFO) {
    return { type: ScreenType.BLOCK_INFO, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.LINKS) {
    return { type: ScreenType.BLOCK_LINK, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.CHAT) {
    return { type: ScreenType.BLOCK_CHAT, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.TASK_LIST) {
    return { type: ScreenType.BLOCK_TASKS, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.FILES_RECENT) {
    return { type: ScreenType.FILES_RECENT, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.HELP) {
    return { type: ScreenType.BLOCK_HELP, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.REQUEST) {
    return { type: ScreenType.BLOCK_REQUEST, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.MEETINGS) {
    return { type: ScreenType.BLOCK_MEETINGS, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.NOTE) {
    return {
      type: ScreenType.BLOCK_FUSEBASE,
      payload: { editItemId: block.id, title: block.title, noteId: block.noteId, place: block.place },
    };
  }
  if (block.type === PortalBlockType.CONTENT) {
    return {
      type: ScreenType.CONTENT,
      payload: { editItemId: block.id, title: block.title, noteId: block.noteId, place: block.place },
    };
  }
  if (block.type === PortalBlockType.FILES_DASHBOARD) {
    return { type: ScreenType.FILES_DASHBOARD, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.TASKS_DASHBOARD) {
    return { type: ScreenType.TASKS_DASHBOARD, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.CHATS_DASHBOARD) {
    return { type: ScreenType.CHATS_DASHBOARD, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.FILES_BUCKET) {
    return { type: ScreenType.FILES_BUCKET, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.PROJECTION) {
    return { type: ScreenType.PROJECTION, payload: { editItemId: block.id, place: block.place } };
  }
  if (block.type === PortalBlockType.FLEXIBLE) {
    return {
      type: ScreenType.BLOCK_FLEXIBLE,
      payload: { editItemId: block.id, template: block.template, place: block.place },
    };
  }
  return { type: ScreenType.MAIN };
};
